export default __webpack_public_path__ + "static/media/white-belt.1eb01ebd.png";